import { settingsManager } from '../../shared/settings';
import { IPrivacyState } from '../models';

// Hide UX for item insights behind a queryString param
const itemInsightsFlightingQueryParamKey = 'itemInsightsToggle';
const peopleInsightsFlightingQueryParamKey = 'peopleInsightsToggle';
const urlParams = new URLSearchParams(window.location.search);
const itemInsightsToggleEnabled =
  settingsManager.get('itemInsightsToggleEnabled') || urlParams.has(itemInsightsFlightingQueryParamKey);
const peopleInsightsToggleEnabled =
  settingsManager.get('peopleInsightsToggleEnabled') || urlParams.has(peopleInsightsFlightingQueryParamKey);

/**
 * The initial state of the privacy area.
 */
export const privacyInitialState: IPrivacyState = {
  linkedInService: undefined,
  isAdmin: false,
  itemInsightsServiceState: { value: itemInsightsToggleEnabled ? 'Loading' : 'UxNotFlighted' },
  peopleInsightsServiceState: { value: peopleInsightsToggleEnabled ? 'Loading' : 'UxNotFlighted' },
  tenantId: '',
  contactMergeSuggestionsState: false,
  orgContactInsightsState: false,
};
